module.exports = __webpack_public_path__ + "img/code-it.a5d76e27.png";